import { render } from "./CardapioView.vue?vue&type=template&id=bd9c39a2&scoped=true"
import script from "./CardapioView.vue?vue&type=script&lang=js"
export * from "./CardapioView.vue?vue&type=script&lang=js"

import "./CardapioView.vue?vue&type=style&index=0&id=bd9c39a2&lang=scss"
import "./CardapioView.vue?vue&type=style&index=1&id=bd9c39a2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd9c39a2"]])

export default __exports__